export const normalizeSearchQuery = (query: string): string => query.trim().toLowerCase()

export const filterBySearchQuery = <T>(items: T[], query: string, getSearchableValue: (item: T) => string): T[] => {
  const normalizedQuery = normalizeSearchQuery(query)
  if (!normalizedQuery) return items

  return items.filter(item => getSearchableValue(item).toLowerCase().includes(normalizedQuery))
}
